// FullScreenLoading.tsx
import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const FullScreenLoading: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.4)', // fundo tipo modal
        zIndex: 1300, // acima de quase tudo (modal é 1300 no MUI)
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

export default FullScreenLoading;
